import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface AddFactsToChronologyParams {
  caseId: string;
  chronologyId: string;
  factIds: string[];
}

const useAddFactsToChronology = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(async ({ caseId, chronologyId, factIds }: AddFactsToChronologyParams) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { factIds },
    });

    const response = await fetch(
      `${APIBaseChronos}/api/case/${caseId}/chronology/${chronologyId}/add-facts`,
      fetchConfig,
    );

    if (!response.ok) {
      throw new Error('Failed to add facts to chronology');
    }

    return response.json();
  });
};

export default useAddFactsToChronology;
